import VueDropzone from 'vue2-dropzone'
import product from '../product'
import supplierRecallService from '../../../../../services/supplier/supplier-recall'
import communicationProductService, {
    convertFlatProductToTier,
    toUpsertPayload,
    ensureProductsTierIds
} from '../../../../../services/provider/communicationProduct'
import { Product, ENUM_PRODUCT_FIELD_DATA_TYPE, ENUM_DATE_TYPE_DEFAULT_VALUE, normalizeProductFieldDataType } from '../../../../../misc/commons'
import _ from 'lodash'
import excelParser from '../../../../../services/excel-parser'
import moment, { unix } from 'moment-timezone'
export default {
    components: {
        VueDropzone,
        product,
        // async to break circular dependency with ProviderProductTierView which imports this modal
        ProviderProductTierView: () => import('../../../../share/provider-product-tier-view/index.vue')
    },
    data() {
        return {
            loadingInitial: true,
            communicationId: null,
            producFieldMetaList: [],
            products: [],
            errorList: [],
            dropzoneOptions: {
                url: '#',
                acceptedFiles: '.xlsx,.xls,.csv',
                maxFiles: 1,
                maxFilesize: 20,
                previewsContainer: false,
                autoProcessQueue: false
            },
            isFileSelect: false,
            file: null,
            isCustomizedContent: false,
            /** Provider tier import: lock field names to PFD columns; no remapping UI. */
            tierImportMode: false,
            CustomizedfilesUpload: [],
            IsShowCustomizedView: false,
            CustomisedContentId: [],
            CustomLocations: [],
            OriginalProducts: [],
            enumProductFieldDataType: ENUM_PRODUCT_FIELD_DATA_TYPE,
            enumDateTypeDefaultValue: ENUM_DATE_TYPE_DEFAULT_VALUE,
        }
    },
    watch: {
        'CustomisedContentId'(val){

            if(this.CustomisedContentId!=undefined && this.CustomisedContentId.length>0 &&this.CustomisedContentId!=null)
            {
                this.isFileSelect = true
            }
            else{
                this.isFileSelect = false
            }

        },
    },
    methods: {
        forceRerender(communicationId, producFieldMetaList, isCustomizedContent, options = {}) {
            this.loadingInitial = true
            this.isCustomizedContent = isCustomizedContent
            this.resetData()
            this.tierImportMode = !!(options && options.tierImportMode)
            this.communicationId = communicationId
            this.producFieldMetaList = (producFieldMetaList || []).map(x => ({
                ...x,
                type: normalizeProductFieldDataType(x.type)
            }))
            this.$refs.modal.show()
            this.loadingInitial = false
        },

        resetData() {
            this.file = null
            this.isFileSelect = false
            this.communicationId = null
            this.producFieldMetaList = []
            this.products = []
            this.errorList = []
            this.tierImportMode = false
        },

        mapImportedFields(fields) {
            return (fields || [])
                .filter(s => s.field_name != 'Location ID')
                .map(y => {
                    if (this.CustomisedContentId.includes(y.field_name)) {
                        y.is_unique_identifier = true
                    }
                    const type = normalizeProductFieldDataType(y.type)
                    let _val = y.value
                    if (type === this.enumProductFieldDataType.DATE) {
                        _val = { valueDate: y.value && y.value.valueDate }
                    } else if (!_val || typeof _val !== 'object') {
                        _val = { valueText: _val != null ? String(_val) : '' }
                    }
                    return {
                        ...y,
                        type,
                        value: _val
                    }
                })
        },

        onClose() {
            this.$refs.modal.hide()
            this.$emit('onClose')
        },
        addFile(file) {
            this.isFileSelect = false
            this.products=[]
            this.OriginalProducts=[]
            if (file.name && _.isArray(file.name.split('.'))) {
                let ext = file.name.split('.')
                if(this.isCustomizedContent)
                {
                    if (['xlsx'].includes(ext[ext.length - 1])) {
                        this.file = file
                        if (this.isCustomizedContent) {
                            let formData = new FormData()
                            formData.append('file', this.file)
                            excelParser.getExcelHeaders(formData).then(res => {
                                var checkfileformat=res.data.d.includes('Location ID','#Description')
                                if(checkfileformat==true)
                                {
                                    if (!res.error) {
                                        this.CustomizedfilesUpload=[]
                                        this.CustomisedContentId=[]
                                        res.data.d.forEach(x => {
                                            if(x!='Location ID' && x!='#Description')
                                            {
                                                this.CustomizedfilesUpload.push({
                                                    text: x,
                                                    value: x
                                                })
                                            }
                                        })
                                    }
                                }
                                else{
                                    this._showToast('Please choose the correct format of the product template', { variant: 'danger' })
                                    this.file=null
                                }

                            })
                        }
                        else{
                            this.isFileSelect = true
                        }
                        this.IsShowCustomizedView = true
                    } else {
                        this._showToast('Only accept xlsx file format', { variant: 'danger' })
                    }
                }
                else{
                    if (['xls', 'xlsx', 'csv'].includes(ext[ext.length - 1])) {
                        this.file = file

                        let formData = new FormData()
                        formData.append('file', this.file)

                        this.isFileSelect = true
                    } else {
                        this._showToast('Only accept xls, xlsx, csv file format', { variant: 'danger' })
                    }
                }
            }
        },

        submitFile(e) {
            if (this.isFileSelect && this.file) {

                let formData = new FormData()
                formData.append('id', this.communicationId)
                formData.append('isCustomisdContent', this.isCustomizedContent)
                formData.append('UniqueColumn', this.CustomisedContentId)
                formData.append('file', this.file)
                this.products = []
                this.errorList = []
                supplierRecallService.readProductFileAtStep1Products(formData).then(res => {
                    if (!res.error) {
                        if(res.data.d.existinguniquecheck)
                        {
                            this.OriginalProducts = res.data.d.success_list_duplicate.map((x, index) => {
                                if(x.customisedLocationId.length>0)
                                {
                                    this.CustomLocations.push(x.customisedLocationId[0].LoactionId)
                                }
                                return new Product({
                                    id: null,
                                    description: x.description,
                                    fields: x.fields.map(y => {
                                        let _val = y.value
                                        if (y.type === 'Date') {
                                            _val = { valueDate: y.value.valueDate }
                                        }
                                        return {
                                            ...y,
                                            value: _val
                                        }
                                    }),
                                    order: index + 1
                                })
                            })
                            this.isFileSelect = false
                            this.file = null
                            if (res.data.d.checkduplicate) {
                                if(res.data.d.existinguniquecheck)
                                {
                                    this._showConfirm('There are duplicate records in the excel file. Please confirm if the file still needs to be uploaded by dropping the duplicate records?').then(confirm => {
                                        if (confirm) {
                                            this.products = this.buildProductsList(res.data.d.success_list)
                                            this.errorList = res.data.d.error_list
                                            if(res.data.d.success_list.length>0)
                                            {
                                                this._showToast('Read file successfully')
                                            }
                                            else{
                                                this.CustomisedContentId=[]
                                                this.IsShowCustomizedView=false
                                                this.CustomizedfilesUpload=[]
                                                if(res.data.d.success_list.length<=0 && res.data.d.success_list.length<=0 && res.data.d.checkduplicate)
                                                {
                                                    this._showToast('All records are duplicate', { variant: 'danger' })
                                                }
                                                else{
                                                    this._showToast('Please choose the correct format of the product template', { variant: 'danger' })
                                                }

                                            }
                                        }
                                        else{
                                            this.file=null
                                            this.CustomisedContentId=[]
                                            this.CustomizedfilesUpload=[]
                                            this.IsShowCustomizedView=false
                                        }
                                    })
                                    e.stopPropagation()
                                }
                                else{
                                    this._showToast('Please choose same unique column(s) ', { variant: 'danger' })
                                    this.CustomisedContentId=[]
                                    this.CustomizedfilesUpload=[]
                                    this.IsShowCustomizedView=false
                                }
                            }
                            else{
                                this.products = this.buildProductsList(res.data.d.success_list)
                                this.errorList = res.data.d.error_list
                                if(res.data.d.success_list.length>0)
                                {
                                    this._showToast('Read file successfully')
                                }
                                else{

                                    this.CustomisedContentId=[]
                                    this.IsShowCustomizedView=false
                                    this.CustomizedfilesUpload=[]
                                    if(res.data.d.error_list.length<=0)
                                    {
                                        this._showToast('The file contains no valid data', { variant: 'danger' })
                                    }
                                }
                            }
                        }
                        else{
                            this._showToast('Please choose same unique column(s) ', { variant: 'danger' })
                            this.CustomisedContentId=[]
                            this.CustomizedfilesUpload=[]
                            this.file=null
                            this.IsShowCustomizedView=false
                        }
                    }

                })

            }
        },

        /**
         * Convert flat imported fields to tier structure based on field definitions
         */
        convertFieldToTierData(fields, fieldDefinitions) {
            const tierData = { 1: {}, 2: {}, 3: {}, 4: {} }

            fields.forEach(field => {
                // producFieldMetaList uses 'name'; API response fields use 'field_name'
                const fieldDef = fieldDefinitions.find(fd =>
                    (fd.name && fd.name === field.field_name) ||
                    (fd.field_name && fd.field_name === field.field_name) ||
                    (fd.field_key && fd.field_key === field.field_key)
                )
                const tier = fieldDef ? (Number(fieldDef.tier_level) || Number(fieldDef.tier) || 1) : 1
                const fieldKey = fieldDef?.field_key || field.field_key || field.field_name

                let value = null
                if (field.value) {
                    if (field.value.valueDate) {
                        value = field.value.valueDate
                        // Unwrap Mongo $date object
                        if (value && typeof value === 'object' && value.$date) {
                            value = value.$date
                        }
                        // Normalize mm/dd/yyyy → ISO so ProviderProductTierView can parse it
                        if (typeof value === 'string' && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) {
                            const [mm, dd, yyyy] = value.split('/')
                            value = `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}T00:00:00.000Z`
                        }
                    } else if (field.value.valueText !== undefined) {
                        value = field.value.valueText
                    } else if (field.value.valueNumber !== undefined) {
                        value = field.value.valueNumber
                    } else if (field.value.valueListSingle !== undefined) {
                        value = field.value.valueListSingle
                    } else if (field.value.valueListMultiple !== undefined) {
                        value = field.value.valueListMultiple
                    } else if (field.value.valueYesNo !== undefined) {
                        value = field.value.valueYesNo
                    } else if (field.value.valueTrueFalse !== undefined) {
                        value = field.value.valueTrueFalse
                    }
                }

                if (value != null && value !== '') {
                    tierData[tier][fieldKey] = typeof value === 'object' && value.$date ? value.$date : String(value)
                }
            })

            return tierData
        },

        /**
         * Convert imported products to tier structure
         */
        convertImportedProductsToTierStructure(importedProducts, fieldDefinitions) {
            if (!importedProducts || importedProducts.length === 0) {
                return []
            }

            // If products are already in tier structure, just return them
            if (importedProducts[0] && importedProducts[0].tier_1_data) {
                return importedProducts
            }

            // Group by product description/name
            const groupedByDescription = {}
            importedProducts.forEach(product => {
                const key = (product.description || '').trim()
                if (!groupedByDescription[key]) {
                    groupedByDescription[key] = []
                }
                groupedByDescription[key].push(product)
            })

            // Convert grouped products to tier structure with cascading duplicate detection
            const tierProducts = Object.entries(groupedByDescription).map(([description, group]) => {
                const tierStructure = {
                    name: description,
                    tier_1_data: []
                }

                // Process each row in the same description group
                group.forEach((product) => {
                    const allTierData = this.convertFieldToTierData(product.fields || [], fieldDefinitions)
                    const tier1Data = allTierData[1] || {}
                    const tier2Data = allTierData[2] || {}
                    const tier3Data = allTierData[3] || {}
                    const tier4Data = allTierData[4] || {}

                    // Find or create tier 1 entry
                    let tier1Entry = tierStructure.tier_1_data.find(t1 =>
                        this.isTierDataEqual(t1.values, tier1Data)
                    )

                    if (!tier1Entry) {
                        tier1Entry = {
                            id: this.generateTierId(),
                            values: tier1Data,
                            tier_2_data: []
                        }
                        tierStructure.tier_1_data.push(tier1Entry)
                    }

                    // Find or create tier 2 entry under matched/current tier 1
                    let tier2Entry = tier1Entry.tier_2_data.find(t2 =>
                        this.isTierDataEqual(t2.values, tier2Data)
                    )

                    if (!tier2Entry) {
                        tier2Entry = {
                            id: this.generateTierId(),
                            values: tier2Data,
                            tier_3_data: []
                        }
                        tier1Entry.tier_2_data.push(tier2Entry)
                    }

                    // Find or create tier 3 entry under matched/current tier 2
                    let tier3Entry = tier2Entry.tier_3_data.find(t3 =>
                        this.isTierDataEqual(t3.values, tier3Data)
                    )

                    if (!tier3Entry) {
                        tier3Entry = {
                            id: this.generateTierId(),
                            values: tier3Data,
                            tier_4_data: []
                        }
                        tier2Entry.tier_3_data.push(tier3Entry)
                    }

                    // Find or create tier 4 entry under matched/current tier 3
                    let tier4Entry = tier3Entry.tier_4_data.find(t4 =>
                        this.isTierDataEqual(t4.values, tier4Data)
                    )

                    if (!tier4Entry) {
                        tier4Entry = {
                            id: this.generateTierId(),
                            values: tier4Data
                        }
                        tier3Entry.tier_4_data.push(tier4Entry)
                    }
                })

                return tierStructure
            })

            return ensureProductsTierIds(tierProducts)
        },

        // Compare tier data values; returns true if all keys and values match (case-insensitive trim)
        isTierDataEqual(values1, values2) {
            const keys1 = Object.keys(values1 || {}).sort()
            const keys2 = Object.keys(values2 || {}).sort()

            if (keys1.length !== keys2.length) return false
            if (!keys1.every((k, i) => k === keys2[i])) return false

            return keys1.every(k => {
                const v1 = (values1[k] || '').toString().trim().toLowerCase()
                const v2 = (values2[k] || '').toString().trim().toLowerCase()
                return v1 === v2
            })
        },

        /**
         * Generate unique ID for tier nodes
         */
        generateTierId() {
            if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
                return crypto.randomUUID()
            }
            return `tier-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
        },

        // Converts API success_list to tier structure (tier mode) or legacy Product objects
        buildProductsList(successList) {
            if (this.tierImportMode) {
                return this.convertImportedProductsToTierStructure(successList, this.producFieldMetaList)
            }
            return successList.map((x, index) => new Product({
                id: null,
                description: x.description,
                fields: this.mapImportedFields(x.fields),
                order: index + 1
            }))
        },

        save() {
            if (this.products && this.products.length > 0) {
                this.$refs['observer'].validate().then(isValid => {
                    if (isValid) {
                        // For tier import mode, this.products already holds tier-structured data
                        if (this.tierImportMode) {
                            try {
                                if (!this.products || this.products.length === 0) {
                                    this._showToast('Failed to convert products to tier structure', { variant: 'danger' })
                                    return
                                }

                                communicationProductService.upsertProducts(
                                    this.communicationId,
                                    toUpsertPayload(this.products)
                                ).then(res => {
                                    if (!res.error) {
                                        this.$refs.modal.hide()
                                        this.resetData()
                                        this.$emit('onCompleted')
                                    } else {
                                        const msg = res.data?.m
                                            || res.message
                                            || 'Failed to save imported products'
                                        this._showToast(msg, { variant: 'danger' })
                                    }
                                }).catch(err => {
                                    this._showToast('Error saving products: ' + (err.message || 'Unknown error'), { variant: 'danger' })
                                })
                            } catch (err) {
                                this._showToast('Error processing products: ' + err.message, { variant: 'danger' })
                            }
                        } else {
                            // Original supplier flow (unchanged)
                            let _products = this.fetchProductItemData()
                            let DuplicateProducts = this.fetchDuplicateProducts()
                            if (_products && _products.length > 0 && _products.length === this.products.length) {
                                supplierRecallService.addNewProductsAtStep1Products({
                                    id: this.communicationId,
                                    products: _products,
                                    duplicateproducts: DuplicateProducts,
                                    customisedContentId: this.CustomisedContentId,
                                    customLocations: this.CustomLocations,
                                    isCustomizedContent: this.isCustomizedContent
                                }).then(res => {
                                    if (!res.error) {
                                        this.$refs.modal.hide()
                                        this.resetData()
                                        this.$emit('onCompleted')
                                    } else {
                                        const msg = res.data?.m
                                            || res.message
                                            || 'Failed to save imported products'
                                        this._showToast(msg, { variant: 'danger' })
                                    }
                                })
                            }
                        }
                    } else {
                        if (!this.tierImportMode && this.CustomisedContentId.length == 0) {
                            this._showToast('It is required to choose at least one column', { variant: 'danger' })
                        } else {
                            this._showToast('Please review product value', { variant: 'danger' })
                        }

                    }
                })
            }

        },

        fetchProductItemData() {
            let _products = []
            for (let i = 0; i < this.products.length; i++) {
                let _product = this.$refs.successProducts[i].fetchProductData()
                if (_product) {
                    _products.push(_product)
                }
            }
            return _products
        },
        fetchDuplicateProducts() {
            let _products = []
            for (let i = 0; i < this.OriginalProducts.length; i++) {
                let _product= {
                    ...this.OriginalProducts[i],
                    fields: this.OriginalProducts[i].fields.map(x => {
                        return {
                            ...x,
                            value: this.fetchValueByType(x.type, x.value)
                        }
                    })
                }
                if (_product) {
                    _products.push(_product)
                }
            }
            return _products
        },

        fetchValueByType(dataType, valueObj){
            let _value = null
            if (!valueObj) return null
            switch (normalizeProductFieldDataType(dataType)) {
            case this.enumProductFieldDataType.TEXT:
                _value = { valueText: (valueObj.valueText || '').trim() }
                break
            case this.enumProductFieldDataType.NUMBER:
                _value = { valueNumber: valueObj.valueNumber }
                break
            case this.enumProductFieldDataType.DATE:
                _value = { valueDate: valueObj.valueDate }
                break
            case this.enumProductFieldDataType.LIST_SINGLE:
                _value = { valueListSingle: valueObj.valueListSingle }
                break
            case this.enumProductFieldDataType.LIST_MULTIPLE:
                _value = { valueListMultiple: valueObj.valueListMultiple }
                break
            case this.enumProductFieldDataType.YES_NO:
                _value = { valueYesNo: valueObj.valueYesNo }
                break
            case this.enumProductFieldDataType.TRUE_FALSE:
                _value = { valueTrueFalse: valueObj.valueTrueFalse }
                break
            }
            return _value
        },

        removeProduct(index) {
            if (this.products && this.products.length > 0) {
                this.products.splice(index, 1)
            }
        },

        downloadTemplate() {
            supplierRecallService.downloadProductTemplate(this.communicationId)
        }
    }
}